import { RouteProps } from "react-router-dom";
import { mainRoute } from "./Main/route";
import { menuRoute } from "./Menu/route";
import { checkoutRoute } from "./Checkout/route";

const routes: RouteProps[] = [mainRoute, menuRoute, checkoutRoute];

export default routes;
